import { AIBadge } from 'ui/badge';
import {
  HeaderRow,
  ColorText,
} from 'modules/ai/nba/components/campaigns/NBACampaignsSlideOver.styles';

export const NBACampaignsSlideOverHeaderContent = () => {
  return (
    <HeaderRow>
      <AIBadge />
      <ColorText>{'Discover campaign suggestions'}</ColorText>
    </HeaderRow>
  );
};
